module.exports = __webpack_public_path__ + "static/media/Hawlucha_gaussian2.11ce7cbb.png";